var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "pallet", attrs: { square: "", flat: "", bordered: "" } },
    [
      _c(
        "q-card-section",
        {
          staticClass: "q-pa-none",
          on: {
            click: function($event) {
              _vm.showPalletDialog = true
            }
          }
        },
        [
          _c("pallet-teaser", { attrs: { pallet: _vm.pallet, name: _vm.name } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-card-section",
        { staticClass: "veneer-log-info-section q-py-none" },
        [_c("pallet-info", { attrs: { pallet: _vm.pallet } })],
        1
      ),
      _vm._v(" "),
      _vm._t("additionalInfo"),
      _vm._v(" "),
      _c("q-separator"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row justify-start q-col-gutter-sm q-pa-sm veneer-card-buttons"
        },
        [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("q-btn", {
                attrs: {
                  "text-color": "primary",
                  size: "11px",
                  icon: "launch",
                  "no-caps": "",
                  "no-wrap": "",
                  flat: "",
                  label: _vm.$t("button.palletLogs")
                },
                on: {
                  click: function($event) {
                    _vm.showPalletDialog = true
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("pallet-dialog", {
        attrs: {
          visible: _vm.showPalletDialog,
          name: _vm.name,
          pallet: _vm.pallet
        },
        on: {
          hide: function($event) {
            _vm.showPalletDialog = false
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }